import React from "react";
import { Button, ButtonToolbar, Form } from "react-bootstrap";
import Icon from "../../../../../components/Icon";

interface ISearchButtonsProps {
  onSubmit: () => void;
  onClear: () => void;
  onCancel: () => void;
  searchDisabled?: boolean;
}

const QuickSearchButtonsGroup = ({
  onSubmit,
  onClear,
  onCancel,
  searchDisabled
}: ISearchButtonsProps) => (
  <Form.Group className={"quick-search-search-buttons__container"}>
    <div className={"flex justify-content-between align-center"}>
      <a
        className={"quick-search-buttons__additional_search_link"}
        href={"https://docs.reversinglabs.com/SpectraAnalyze/advanced-search/"}
        target={"_blank"}
        rel="noreferrer"
      >
        Additional Search Options
      </a>
      <ButtonToolbar className="mt-0">
        <Button
          type={"button"}
          variant="text"
          className={"quick-search-buttons__clear-button"}
          onClick={onClear}
        >
          Clear
        </Button>
        <Button type="reset" variant="outline-primary" onClick={onCancel}>
          CANCEL
        </Button>
        <Button
          type="submit"
          variant="primary"
          onClick={onSubmit}
          disabled={searchDisabled}
        >
          <Icon name={"search"} />
          SEARCH
        </Button>
      </ButtonToolbar>
    </div>
  </Form.Group>
);

export default QuickSearchButtonsGroup;
